import { TypeKeys, WidgetBlockAction } from './types';

type K = { type: unknown; payload: unknown };
type CustomEventAction<T> = WidgetBlockAction<TypeKeys.CUSTOM_EVENT, { event: T }>;

const customEvent = <T extends K>(
    widgetId: string | null | undefined,
    instanceId: string | null | undefined,
    type: unknown,
    payload: unknown,
    debug = false
): CustomEventAction<T> => ({
    type: (debug ? `${TypeKeys.CUSTOM_EVENT}_${widgetId}_${type}` : TypeKeys.CUSTOM_EVENT) as TypeKeys.CUSTOM_EVENT,
    payload: {
        widgetId,
        instanceId,
        event: { type, payload } as T,
    },
});

export default customEvent;
export { CustomEventAction };
